module.exports = __webpack_public_path__ + "static/mockup_phone_landing@2x-f43703512ec9e50c775f7e43cf5b2610.png";